export default{
  communicationToEdit: {
    copy: {
      copy_id: null,
      copy_name: '',
      product: {
        product_id: null,
        product_name: '',
        product_is_active: null,
        product_updated_at: ''
      },
      copy_is_active: null,
      copy_updated_at: ''
    },
    communication_id: null,
    communication_text: '',
    communication_text_normalized: '',
    communication_id_shot: '',
    communication_comment_shot: '',
    communication_type: '',
    communication_is_active: true,
    communication_is_formula_lancamento: true,
    communication_approval: true,
    communication_relationship: true,
    communication_updated_at: ''
  },
  loading: true,
  page: 0,
  size: 200,
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
  is_active: null,
  product_id: '',
  search_text: '',
  items: [],
  newCampaign: true
}


// WEBPACK FOOTER //
// ./src/store/modules/communication/state.js